var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponsDispatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.021,
    height: 21.348,
    viewBox: "0 0 28.021 21.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8140879_billing_discount_coupon_offer_tag_icon",
    "data-name": "8140879_billing_discount_coupon_offer_tag_icon",
    transform: "translate(-1.9 -3.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22332",
    "data-name": "Path 22332",
    d: "M12.028,11.12a1.738,1.738,0,1,0,1.738,1.738A1.738,1.738,0,0,0,12.028,11.12Zm0,2.4a.678.678,0,0,1-.7-.678.7.7,0,1,1,1.373,0,.678.678,0,0,1-.678.678Z",
    transform: "translate(6.081 5.336)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22333",
    "data-name": "Path 22333",
    d: "M11.106,10.848a1.738,1.738,0,1,0-1.738,1.738A1.738,1.738,0,0,0,11.106,10.848Zm-2.4,0a.678.678,0,0,1,.678-.7.7.7,0,1,1,0,1.373.678.678,0,0,1-.678-.678Z",
    transform: "translate(4.118 3.853)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22334",
    "data-name": "Path 22334",
    d: "M13.639,9.217a.5.5,0,0,0-.73.1l-4.4,5.892a.521.521,0,0,0,.122.73.469.469,0,0,0,.3.1.521.521,0,0,0,.5-.174l4.414-5.892a.521.521,0,0,0-.209-.765Z",
    transform: "translate(4.696 3.849)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22335",
    "data-name": "Path 22335",
    d: "M25.6,3.89H6.134A4.084,4.084,0,0,0,2.05,7.975v.174a4.1,4.1,0,0,0,4.084,4.084h.1v9.75a2.885,2.885,0,0,0,2.885,2.955h13.5a2.885,2.885,0,0,0,2.885-2.868V12.181h0a4.1,4.1,0,0,0,4.258-4.032V7.975A4.084,4.084,0,0,0,25.6,3.89ZM22.628,23.825H9.124a1.86,1.86,0,0,1-1.842-1.842V8.791H24.557V21.983a1.86,1.86,0,0,1-1.929,1.842ZM28.641,8.183A3.059,3.059,0,0,1,25.6,11.19h0v-2.4h1.078A.521.521,0,0,0,27.2,8.27a.5.5,0,0,0-.521-.521H5.161a.521.521,0,0,0-.521.521.539.539,0,0,0,.521.521H6.239v2.433h-.1A3.059,3.059,0,0,1,3.093,8.148V7.975A3.041,3.041,0,0,1,6.134,4.933H25.6a3.041,3.041,0,0,1,3.041,3.041Z",
    transform: "translate(0 0)",
    stroke: "#000",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsDispatch);
export default __webpack_public_path__ + "static/media/Coupons-Dispatch.08c03d5d93fcad5dc8082766991f42cb.svg";
export { ForwardRef as ReactComponent };